import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../../../../components/Button";
import { Modules, AuthRoutes, RouteParamsTypes, PermissionModulesEnum, PermissionActionsEnum } from "../../../../../enums";
import { hasResourseAccess } from "../../../../../utils/methods";
import { AuthContext } from "../../../../../contexts/AuthContext";

const Header: React.FC = () => {
  const { t } = useTranslation();
  const { isSystemAdmin, permissions } = useContext(AuthContext);
  const navigate = useNavigate();

  const hasAddAccess = hasResourseAccess(isSystemAdmin, permissions, { accessibleTo: [{ [PermissionModulesEnum.Property]: [PermissionActionsEnum.Add] }] })

  const handleAddNewClick = () => {
    navigate(Modules.resources + AuthRoutes.properties + RouteParamsTypes.add);
  };

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t("property.list.pageTexts.header.title")}</h4>
        <p>{t("property.list.pageTexts.header.subTitle")}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end">
        {hasAddAccess && (
          <div className="add-new">
            <Button
              className="btn btn-primary waves-effect waves-light"
              onClick={handleAddNewClick}
              text={t("property.list.pageTexts.header.addNewButton")}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;